import styled, { css } from 'styled-components';

export const YOUTUBE_THUMBNAIL_CROP = 94;

export const isYoutubePlatform = (platform: string) =>
  platform.toUpperCase() === 'YOUTUBE';

export const ContentCardThumbnail = styled.img<{ $isYoutube?: boolean }>`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;

  ${({ $isYoutube }) =>
    $isYoutube &&
    css`
      position: absolute;
      left: 0;
      width: 100%;
      height: calc(100% + ${YOUTUBE_THUMBNAIL_CROP * 2}px);
      top: -${YOUTUBE_THUMBNAIL_CROP}px;
    `}
`;
